module.exports = __webpack_public_path__ + "img/fdtech02.d5e7ca88.png";